var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStopWatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90996 2.26866V1.18152H7.4062C7.73244 1.18152 7.99696 0.917002 7.99696 0.59076C7.99696 0.264519 7.73249 0 7.4062 0H4.59418C4.26794 0 4.00342 0.264519 4.00342 0.59076C4.00342 0.917002 4.26794 1.18152 4.59418 1.18152H5.09042V2.26866C2.26715 2.70748 0.0994873 5.15493 0.0994873 8.09923C0.0994873 11.3529 2.74657 13.9999 6.00019 13.9999C9.25381 13.9999 11.9009 11.3529 11.9009 8.09923C11.9009 5.15493 9.73323 2.70748 6.90996 2.26866ZM6.00019 12.8185C3.39801 12.8185 1.28101 10.7014 1.28101 8.09928C1.28101 5.49714 3.39806 3.38009 6.00019 3.38009C8.60232 3.38009 10.7194 5.49714 10.7194 8.09928C10.7194 10.7014 8.60237 12.8185 6.00019 12.8185Z",
    fill: "#FF0082"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59107 7.85388V5.07074C6.59107 4.7445 6.32655 4.47998 6.00031 4.47998C5.67406 4.47998 5.40955 4.7445 5.40955 5.07074V8.19468C5.40955 8.29076 5.44783 8.38288 5.51588 8.45065L7.16855 10.0964C7.39979 10.3266 7.77377 10.3258 8.00403 10.0946C8.23423 9.86341 8.23343 9.48935 8.00228 9.25914L6.59107 7.85388Z",
    fill: "#FF0082"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopWatch);
export default __webpack_public_path__ + "static/media/stop-watch.fc0b18c72141a657f34c85fd6c2f507d.svg";
export { ForwardRef as ReactComponent };